import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'msToMinutes'
})
export class MsToMinutesPipe implements PipeTransform {

  transform(value: number): string {
    if (!value && value !== 0) return '';
    const minutes = Math.floor(value / 60000); // 1 min = 60000 ms
    const seconds = Math.floor((value % 60000) / 1000);

    return `${minutes} min ${seconds < 10 ? '0' : ''}${seconds} s`;
  }

}